import React from 'react';
import { Logo } from '../../layout/BotBuilderSidebar/Logo/Logo';
import { OptOutForm } from './OptOutForm/OptOutForm';
import { OptOutFooter } from './OptOutFooter/OptOutFooter';
import styles from './OptOutPage.module.css';

export const OptOutPage = () => (
  <div className={styles.container}>
    <div className={styles.body}>
      <Logo className={styles.logo} />
      <h1 className={styles.title}>Do not sell my personal information</h1>
      <OptOutForm />
    </div>
    <div className={styles.footer}>
      <OptOutFooter />
    </div>
  </div>
);
